var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _g2, _g3, _path8, _path9, _path10, _path11, _g4, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 205,
    viewBox: "0 0 235 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.47 178.373C164.47 178.373 202.573 140.231 202.573 93.0134C202.573 45.7962 164.302 7.65283 117.47 7.65283C70.4701 7.65283 32.3666 45.7962 32.3666 93.0134C32.3666 140.231 70.4701 178.373 117.47 178.373Z",
    fill: "url(#paint0_linear_16_72)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.034 37.3033C200.836 37.3033 203.916 34.2189 203.916 30.414C203.916 26.6091 200.836 23.5247 197.034 23.5247C193.234 23.5247 190.152 26.6091 190.152 30.414C190.152 34.2189 193.234 37.3033 197.034 37.3033Z",
    fill: "#253040"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M207.106 10.1733C209.701 10.1733 211.806 8.06679 211.806 5.46835C211.806 2.86989 209.701 0.763428 207.106 0.763428C204.51 0.763428 202.406 2.86989 202.406 5.46835C202.406 8.06679 204.51 10.1733 207.106 10.1733Z",
    fill: "#253040"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8986 37.1352C39.4943 37.1352 41.5986 35.0287 41.5986 32.4303C41.5986 29.8318 39.4943 27.7253 36.8986 27.7253C34.3029 27.7253 32.1986 29.8318 32.1986 32.4303C32.1986 35.0287 34.3029 37.1352 36.8986 37.1352Z",
    fill: "#253040"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1214 138.842C21.9421 138.842 25.85 134.93 25.85 130.104C25.85 125.279 21.9421 121.367 17.1214 121.367C12.3007 121.367 8.39282 125.279 8.39282 130.104C8.39282 134.93 12.3007 138.842 17.1214 138.842Z",
    fill: "#253040"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.388 148.71H49.5501C43.3046 148.71 38.2301 143.631 38.2301 137.379V50.2415C38.2301 43.9895 43.3046 38.9097 49.5501 38.9097H185.388C191.634 38.9097 196.708 43.9895 196.708 50.2415V137.769C196.319 143.631 191.245 148.71 185.388 148.71Z",
    fill: "#4A5463"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8023 43.1704H64.6356C63.7086 43.1704 62.957 43.9227 62.957 44.8507V50.1486C62.957 51.0766 63.7086 51.8289 64.6356 51.8289H84.8023C85.7293 51.8289 86.4809 51.0766 86.4809 50.1486V44.8507C86.4809 43.9227 85.7293 43.1704 84.8023 43.1704Z",
    fill: "#131F2E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.124 42.9255H148.958C148.031 42.9255 147.279 43.6778 147.279 44.6059V49.9037C147.279 50.8318 148.031 51.5841 148.958 51.5841H169.124C170.051 51.5841 170.803 50.8318 170.803 49.9037V44.6059C170.803 43.6778 170.051 42.9255 169.124 42.9255Z",
    fill: "#131F2E"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_16_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.1194 23.2795H66.3348V46.9139H83.1194V23.2795Z",
    fill: "#4A5463"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_16_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.441 23.5247H150.657V47.159H167.441V23.5247Z",
    fill: "#4A5463"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4129 98.6943C94.5271 98.6943 100.294 92.9212 100.294 85.7996C100.294 78.6781 94.5271 72.9048 87.4129 72.9048C80.2988 72.9048 74.5317 78.6781 74.5317 85.7996C74.5317 92.9212 80.2988 98.6943 87.4129 98.6943Z",
    stroke: "#D0D8DD",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7249 119.8C66.7249 108.468 76.093 99.0901 87.4129 99.0901C98.7329 99.0901 108.101 108.468 108.101 119.8",
    stroke: "#D0D8DD",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M129.57 83.4551H171.337",
    stroke: "#D0D8DD",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M129.57 104.556H145.964",
    stroke: "#D0D8DD",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_16_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.37 165.18C142.829 167.483 142.017 169.922 141.07 171.955C138.498 176.967 134.438 180.896 129.43 183.47C124.287 186.044 118.197 187.128 112.107 185.774C97.7607 182.793 88.5576 168.702 91.535 154.341C94.5126 139.98 108.453 130.632 122.799 133.748C127.942 134.832 132.408 137.406 136.197 140.929C142.558 147.296 145.265 156.509 143.37 165.18Z",
    fill: "url(#paint1_linear_16_72)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111.844 152.865C112.156 152.553 112.572 152.344 112.987 152.136C113.403 151.928 113.819 151.719 114.234 151.511C114.65 151.302 115.169 151.197 115.688 151.093C116.208 150.988 116.83 150.987 117.453 150.986C118.284 150.985 119.011 151.087 119.737 151.398C120.36 151.605 120.982 152.02 121.397 152.435C121.811 152.85 122.226 153.473 122.536 153.992C122.743 154.616 122.846 155.343 122.948 156.07C122.947 156.694 122.843 157.422 122.53 157.942C122.322 158.358 122.01 158.878 121.697 159.398C121.385 159.71 120.97 160.127 120.658 160.439C120.242 160.648 119.93 160.96 119.514 161.168C119.203 161.481 118.891 161.585 118.579 161.897C118.371 162.105 118.163 162.314 118.162 162.729L117.744 164.809L115.356 164.708L115.256 162.318C115.257 161.902 115.257 161.486 115.466 161.071C115.674 160.654 115.882 160.446 116.194 160.134C116.506 159.822 116.921 159.613 117.233 159.301C117.649 159.092 117.961 158.78 118.273 158.468C118.585 158.156 118.897 157.843 119.105 157.427C119.313 157.011 119.418 156.491 119.522 155.972C119.627 155.66 119.523 155.348 119.42 155.036C119.317 154.725 119.109 154.517 118.902 154.31C118.695 154.102 118.383 153.999 118.072 153.895C117.761 153.792 117.449 153.688 117.034 153.689C116.619 153.69 116.1 153.794 115.684 153.795C115.373 153.899 115.061 154.004 114.645 154.212C114.334 154.317 114.126 154.525 114.022 154.629C113.918 154.733 113.71 154.733 113.502 154.734C113.191 154.838 112.88 154.527 112.776 154.215L111.844 152.865ZM114.103 169.699C114.103 169.491 114.207 169.179 114.312 168.867C114.416 168.555 114.624 168.347 114.832 168.139C115.248 167.723 115.871 167.514 116.494 167.513C116.702 167.512 117.013 167.616 117.324 167.719C117.636 167.823 117.843 168.03 118.05 168.238C118.672 168.861 118.878 169.9 118.462 170.732C118.357 171.044 118.15 171.252 117.942 171.46C117.734 171.668 117.422 171.773 117.214 171.981C116.902 172.085 116.695 172.085 116.279 172.086C116.072 172.086 115.656 172.087 115.449 171.88C114.931 171.569 114.516 171.153 114.309 170.738C114.102 170.322 113.998 170.011 114.103 169.699Z",
    fill: "#384252"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_72",
    x: 16.2301,
    y: 27.9097,
    width: 202.478,
    height: 153.801,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_72"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_72",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_16_72",
    x: 44.3348,
    y: 12.2795,
    width: 60.7845,
    height: 67.6343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_72"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_72",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_16_72",
    x: 128.657,
    y: 12.5247,
    width: 60.7847,
    height: 67.6343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_72"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_72",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_16_72",
    x: 86.9756,
    y: 133.148,
    width: 60.9884,
    height: 61.2117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_72"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_72",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_72",
    x1: 38.0401,
    y1: 178.373,
    x2: 148.537,
    y2: -16.4195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354953,
    stopColor: "#131F2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642863,
    stopColor: "#253040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384252"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16_72",
    x1: 103.13,
    y1: 147.117,
    x2: 126.068,
    y2: 185.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3EAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB6C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactive);
export default __webpack_public_path__ + "static/media/inactive.3866f2a3242db0c5d618ed59cb56e1ef.svg";
export { ForwardRef as ReactComponent };